import { useQuery } from "react-query";
import { RelatorioUnidadesTotais } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

function useRelatorioUnidadesTotais() {
  return useQuery<RelatorioUnidadesTotais, AxiosError>(
    [`/v1/relatorios/unidades/totais`],
    async () => {
      const { data } = await http.get<RelatorioUnidadesTotais>(
        "/v1/relatorios/unidades/total-pessoas"
      );

      return data;
    }
  );
}

export default useRelatorioUnidadesTotais;
